export function formatDateFromTimestamp(timestamp?: number): string {
  if (timestamp == null) return "";
  const date = new Date(timestamp * 1000);
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "2-digit",
  });
}

export function addDaysToDate(from: Date, days?: number): Date {
  if (days == null || Number.isNaN(days)) return new Date(from);
  const d = new Date(from);
  d.setDate(d.getDate() + days);
  return d;
}

export function unixSecondsToDate(sec?: number): Date | undefined {
  if (sec == null) return undefined;
  return new Date(sec * 1000);
}

export function dateToUnixSeconds(d: Date): number {
  return Math.floor(d.getTime() / 1000);
}

export function toDateInputValue(d: Date): string {
  const y = d.getFullYear();
  const m = `${d.getMonth() + 1}`.padStart(2, "0");
  const day = `${d.getDate()}`.padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function fromDateInputValue(s: string): Date {
  const [y, m, d] = s.split("-").map(Number);
  return new Date(y, (m || 1) - 1, d || 1);
}
